import React, { Fragment, useEffect, useState } from 'react'
import Users from './users'
import Permissions from './permissions'
import { Button, Icon as AntdIcon, Tooltip } from 'antd'
import CheckInput from '../../components/CheckInput'

const USERS = 'Users'
const PERMISSIONS = 'Permissions'

const style = {
  fontSize: 20,
  verticalAlign: '0.1em',
}

const styleButton = {
  boxShadow: 'none',
}

const Detail = ({
  item,
  users,
  collections,
  update,
  reload,
  isActiveSave,
  save,
}) => {
  const [tab, setTab] = useState(item.support ? PERMISSIONS : USERS)
  useEffect(() => {
    if (item.support) {
      setTab(PERMISSIONS)
    }
  }, [item.name])
  return (
    <div className="col-8">
      DETAILS
      <div className="my-2 border collectionItem knackly-plain p-4">
        <div className={'row'}>
          <div className="col-6">
            <h2>{item.name}</h2>
          </div>
          <div className={'col-6'}>
            {isActiveSave && <div className={'float-right'}>
              <Tooltip placement="bottom" title={'Save'}>
                <Button shape="circle" style={styleButton}
                        className="m-1 border-0 bg-transparent"
                        onClick={async () => save()}>
                  <AntdIcon type="save" style={style}/>
                </Button>
              </Tooltip>
              <Tooltip placement="bottom" title={'Cancel'}>
                <Button shape="circle" style={styleButton}
                        className="m-1 border-0 bg-transparent"
                        onClick={() => reload()}>
                  <AntdIcon type="close" style={style}/>
                </Button>
              </Tooltip>
            </div>}
          </div>
          <div className="col-12">
            {item.support && (<div>
              <CheckInput id={'hasSupportAccess'}
                          label={'Allow Support Access'}
                          className={'form-group form-check mt-3'}
                          checked={item.hasSupportAccess}
                          onChange={() => update(
                            { hasSupportAccess: !item.hasSupportAccess })}/>

            </div>)}
            {item.hasSupportAccess && (<Fragment>
              <ul className="nav nav-tabs text-uppercase" role="tablist">
                {!item.support &&
                  (<li key={USERS} className="nav-item mr-2 cursorPointer"
                       onClick={() => {
                         setTab(USERS)
                       }
                       }>
                    <div
                      className={USERS === tab ? 'nav-link active' : 'nav-link'}
                      role="tab"
                      aria-selected="true">{USERS}</div>
                  </li>)}
                <li key={PERMISSIONS} className="nav-item mr-2 cursorPointer"
                    onClick={() => {
                      setTab(PERMISSIONS)
                    }
                    }>
                  <div className={PERMISSIONS === tab
                    ? 'nav-link active'
                    : 'nav-link'}
                       role="tab"
                       aria-selected="true">{PERMISSIONS}</div>
                </li>
              </ul>
              <div className={'w-100 p-2 knackly-back overflow-auto'}
                   style={{ maxHeight: '72vh' }}>
                {tab === USERS &&
                  <Users users={item.users || []} usersOfTenant={users}
                         update={update}/>}
                {tab === PERMISSIONS &&
                  <Permissions permissions={item.permissions || []}
                               collections={collections} update={update}/>}
              </div>
            </Fragment>)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Detail
